import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '@hetivo/hetivo-lib-web-utils';
import { MainSelector } from '&/features/main-selector';
import { ComingSoonPlaceholder } from '&/features/settings/components';

function HomePage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <PageHeader
        breadcrumb={<MainSelector />}
        description={t('pages.home.subtitle')}
        title={t('pages.home.title')}
        variant="banner"
      />
      <ComingSoonPlaceholder feature={t('navigation.dashboard')} />
    </div>
  );
}

export const Route = createFileRoute('/_authenticated/')({
  component: HomePage,
  staticData: { titleKey: 'home' },
});
